export default __webpack_public_path__ + "static/media/P-004.efaba165.png";